import { useEffect, useState } from "react";

export const useGeoLocation = () => {
    const [location, setLocation] = useState({ source: 'unknown' });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchIPLocation = async () => {
            try {
                const res = await fetch("https://ipapi.co/json/");
                const data = await res.json();

                setLocation({
                    lat: data.latitude,
                    lng: data.longitude,
                    city: data.city,
                    country: data.country_name,
                    ip: data.ip,
                    source: 'ip'
                });
                setLoading(false);
            } catch (err) {
                console.warn("IP location fallback failed:", err);
                setError(err);
                setLoading(false);
            }
        };

        const success = (position) => {
            const { latitude, longitude } = position.coords;
            setLocation({
                lat: latitude,
                lng: longitude,
                source: 'gps'
            });

            // Optionally supplement with IP info for city/country
            fetch("https://ipapi.co/json/")
                .then(res => res.json())
                .then(data => {
                    setLocation(prev => ({
                        ...prev,
                        city: data.city,
                        country: data.country_name,
                        ip: data.ip
                    }));
                })
                .catch(err => console.warn("Failed to get IP location supplement:", err))
                .finally(() => setLoading(false));
        };

        const locationError = (err) => {
            console.warn("Browser location permission denied. Falling back to IP...", err);
            setError(err);
            fetchIPLocation();
        };

        // Start with GPS location if available
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(success, locationError, {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 300000 // Cache for 5 minutes
            });
        } else {
            console.warn("Geolocation not supported by browser. Using IP location...");
            fetchIPLocation();
        }
    }, []);

    return { location, loading, error };
};
